// App.js
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/Footer/Footer";
import "./App.css";

// Code splitting avec lazy loading pour améliorer les performances
const Home = lazy(() => import("./pages/Home/Home"));
const Portfolio = lazy(() => import("./pages/Portfolio/Portfolio"));
const About = lazy(() => import("./pages/About/About"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Prestations = lazy(() => import("./pages/Prestations/Prestations"));

// Composant de chargement
const LoadingFallback = () => (
  <div className="loading-fallback">
    <div className="loading-spinner" />
  </div>
);

const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/portfolio/:folder" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
